export const MB = 1024 * 1024;

export const FILE_TYPE_EXCEL_XLSX = '504b34';

export const ALLOWED_FILE_TYPES = ['xlsx', 'xlsm'];

export const MAX_UPLOAD_CELL_SIZE = 300 * 300 * 5;
export const WARNING_UPLOAD_CELL_SIZE = (300 * 300 * 5) / 2;
